import { useState } from "react";
import { Button, Flex, Modal, Typography, Divider } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

interface AlertModalProps {
  storageKey: string;
  title?: string;
  message: React.ReactNode;
  showDivider?: boolean;
}

export const AlertModal = ({
  storageKey,
  title = "Atenção",
  message,
  showDivider = false,
}: AlertModalProps) => {
  const [isModalOpen, setIsModalOpen] = useState(() => {
    const opened = sessionStorage.getItem(storageKey);
    return !opened;
  });

  const handleOk = () => {
    sessionStorage.setItem(storageKey, "false");
    setIsModalOpen(false);
  };

  return (
    <Modal
      title={
        <Flex gap={8} align="center">
          <ExclamationCircleOutlined style={{ color: "#40A9FF" }} />
          <Typography.Text strong>{title}</Typography.Text>
        </Flex>
      }
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={
        <Button type="primary" onClick={handleOk}>
          Ciente
        </Button>
      }
    >
      {showDivider && <Divider style={{ margin: "12px 0" }} />}
      <Typography.Text>{message}</Typography.Text>
    </Modal>
  );
};
